import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { 
  FaLaptopCode, 
  FaMobileAlt, 
  FaEthereum, 
  FaReact, 
  FaNodeJs, 
  FaAngular, 
  FaConnectdevelop,
  FaSwift
} from "react-icons/fa";
import { 
  SiSymfony, 
  SiFlutter, 
  SiFirebase, 
  SiEthereum, 
  SiSolidity,
  SiWeb3Dotjs
} from "react-icons/si";
import "./Services.css";

function Services() {
  return (
    <Container fluid>
      <Row className="mt-5">
        <Col md={12}>
          <div className="services-intro">
            <h1 className="services-heading">
              My <strong className="purple">Services</strong>
            </h1>
            <div className="services-divider">
              <div className="divider-line"></div>
              <div className="divider-icon">⚡</div>
              <div className="divider-line"></div>
            </div>
            <p className="services-subtitle">
              I provide comprehensive solutions for your digital needs with cutting-edge technologies
            </p>
          </div>
        </Col>
      </Row>
      
      <Row className="services-row">
        {/* Web Development Card */}
            <Col lg={4} md={6} className="service-card-wrapper">
              <div className="service-card web-dev">
                <div className="service-card-inner">
                  <div className="service-header">
                <div className="service-icon-container">
                  <FaLaptopCode className="service-main-icon"/>
                </div>
                <h3>Web Development</h3>
                  </div>
                  <div className="service-content">
                <p>
                  Elegant, scalable, and easy to use responsive web applications 
                  built using modern technologies and best practices.
                </p>
                <div className="service-technologies">
                  <div className="tech-badge">
                    <FaReact className="tech-icon" />
                    <span>React</span>
                  </div>
                  <div className="tech-badge">
                    <FaNodeJs className="tech-icon" />
                    <span>Node.js</span>
                  </div>
                  <div className="tech-badge">
                    <FaAngular className="tech-icon" />
                    <span>Angular</span>
                  </div>
                  <div className="tech-badge">
                    <SiSymfony className="tech-icon" />
                    <span>Symfony</span>
                  </div>
                  <div className="tech-badge">
                    <SiSymfony className="tech-icon" />
                    <span>Spring Boot</span>
                  </div>
                </div>
                  </div>
                  <div className="service-action">
                  </div>
                </div>
              </div>
            </Col>
            
            {/* Mobile Application Card */}
        <Col lg={4} md={6} className="service-card-wrapper">
          <div className="service-card mobile-dev">
            <div className="service-card-inner">
              <div className="service-header">
                <div className="service-icon-container">
                  <FaMobileAlt className="service-main-icon"/>
                </div>
                <h3>Mobile Application</h3>
              </div>
              <div className="service-content">
                <p>
                  Optimized native applications with intuitive UIs, powered by 
                  scalable back-ends, tailored for your business requirements.
                </p>
                <div className="service-technologies">
                  <div className="tech-badge">
                    <FaReact className="tech-icon" />
                    <span>React Native</span>
                  </div>
                  <div className="tech-badge">
                    <SiFlutter className="tech-icon" />
                    <span>Flutter</span>
                  </div>
                  <div className="tech-badge">
                    <SiFirebase className="tech-icon" />
                    <span>Firebase</span>
                  </div>
                  <div className="tech-badge">
                    <FaSwift className="tech-icon" />
                    <span>Swift</span>
                  </div>
                </div>
              </div>
              <div className="service-action">
              </div>
            </div>
          </div>
        </Col>
        
        {/* Blockchain Development Card */}
        <Col lg={4} md={12} className="service-card-wrapper">
          <div className="service-card blockchain-dev">
            <div className="service-card-inner">
              <div className="service-header">
                <div className="service-icon-container">
                  <FaEthereum className="service-main-icon"/>
                </div>
                <h3>Blockchain Development</h3>
              </div>
              <div className="service-content">
                <p>
                  Next-generation blockchain applications that combine security, 
                  transparency and usability for the web3 ecosystem.
                </p>
                <div className="service-technologies">
                  <div className="tech-badge">
                    <SiSolidity className="tech-icon" />
                    <span>Solidity</span>
                  </div>
                  <div className="tech-badge">
                    <SiWeb3Dotjs className="tech-icon" />
                    <span>Web3</span>
                  </div>
                  <div className="tech-badge">
                    <SiEthereum className="tech-icon" />
                    <span>Ethereum</span>
                  </div>
                  <div className="tech-badge">
                    <FaConnectdevelop className="tech-icon" />
                    <span>Smart Contracts</span>
                  </div>
                </div>
              </div>
              <div className="service-action">
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Services;